import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { ref, onValue } from "firebase/database";

export default function PassbookStatus() {
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    if (user && user._key && user._node) {
      setCurrentUser(user);
      const docsRef = ref(db, `${user._node}/${user._key}/documents`);

      const unsubscribe = onValue(docsRef, (snapshot) => {
        if (snapshot.exists()) {
          setUploadedFiles(snapshot.val());
        } else {
          setUploadedFiles({});
        }
        setLoading(false);
      });
      return () => unsubscribe();
    } else {
      setLoading(false);
    }
  }, []);

  const getRoleStatus = (roleName) => {
    const roleField = `approvedBy${roleName.charAt(0).toUpperCase() + roleName.slice(1)}`;
    const docIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    // Check if any documents exist first
    if (Object.keys(uploadedFiles).length === 0) return "Pending";

    // Check if all 12 documents are approved by this role
    const isAllApproved = docIds.every(id => {
      const doc = uploadedFiles[id];
      return doc && doc[roleField] === true;
    });

    return isAllApproved ? "Approved" : "Pending";
  };

  const data = [
    { id: 1, role: "Incharge Status", status: getRoleStatus("incharge"), remarks: "" },
    { id: 2, role: "Accountant Status", status: getRoleStatus("accountant"), remarks: "" },
    { id: 3, role: "Engineer Status", status: getRoleStatus("engineer"), remarks: "" },
    { id: 4, role: "Admin Status", status: getRoleStatus("admin"), remarks: "" },
    { id: 5, role: "CEO Status", status: getRoleStatus("ceo"), remarks: "" },
  ];

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <div className="spinner"></div>
        <style>{`
          .spinner {
            width: 40px;
            height: 40px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #3498db;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div style={{ padding: "0 0 24px 0" }}>
      <div
        style={{
          background: "#fff",
          borderRadius: 6,
          padding: 20,
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <h3 style={{ marginBottom: 15 }}>स्थिती तपशील (Status Details)</h3>

        {/* Top Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
        >
          <div>
            <button className="btn">Copy</button>
            <button className="btn">Excel</button>
            <button className="btn">Print</button>
          </div>

          <div>
            Search: <input type="text" style={{ padding: 5, border: "1px solid #ddd", borderRadius: "4px" }} />
          </div>
        </div>

        {/* Table */}
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f1f1f1" }}>
            <tr>
              <th className="th">#</th>
              <th className="th">Role</th>
              <th className="th">Status</th>
              <th className="th">Remarks.</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr
                key={item.id}
                style={{
                  background: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                }}
              >
                <td className="td">{index + 1}</td>
                <td className="td">{item.role}</td>

                <td className="td">
                  <span
                    style={{
                      color:
                        item.status === "Approved" ? "#10b981" : "#f59e0b",
                      fontWeight: "700",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      background: item.status === "Approved" ? "#ecfdf5" : "#fffbeb",
                      fontSize: "12px",
                      textTransform: "uppercase"
                    }}
                  >
                    {item.status === "Approved" ? "स्वीकृत (Approved)" : "प्रलंबित (Pending)"}
                  </span>
                </td>

                <td className="td">{item.remarks}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 15,
          }}
        >
          <div>Showing 1 to 5 of 5 entries</div>

          <div>
            <button className="pageBtn">Previous</button>
            <button className="pageBtn active">1</button>
            <button className="pageBtn">Next</button>
          </div>
        </div>
      </div>

      {/* Styles */}
      <style>
        {`
          .btn {
            background: #6c757d;
            color: white;
            border: none;
            padding: 6px 12px;
            margin-right: 5px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 13px;
            font-weight: 600;
          }

          .th {
            border: 1px solid #ddd;
            padding: 12px 10px;
            text-align: left;
            font-size: 14px;
            color: #4b5563;
          }

          .td {
            border: 1px solid #ddd;
            padding: 12px 10px;
            font-size: 14px;
            color: #374151;
          }

          .pageBtn {
            padding: 6px 10px;
            border: 1px solid #ccc;
            margin-left: 5px;
            background: white;
            cursor: pointer;
            font-size: 13px;
          }

          .pageBtn.active {
            background: #5c6ac4;
            color: white;
            border-color: #5c6ac4;
          }
        `}
      </style>
    </div>
  );
}
